import React, { useState, useEffect } from "react";
import { faDownload, faPlayCircle, faPlus, faShareAlt, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ScrollContainer from "react-indiana-drag-scroll";
import {
    Card, CardImgOverlay, CardImg,
    Spinner
} from "reactstrap";
import axios from "axios";
import { environment } from "../../enviornments/enviornment";
import "./styles/SingleMovie.scss";

const SingleMoviePage = (props) => {
    const [data, setData] = useState(null);
    let url = props.history.location.state ? props.history.location.state.dataUrl : `https://api.themoviedb.org/3/movie/${props.match.params.itemId}`;
    useEffect(() => {
        axios.get(`${url}?api_key=${environment.MovieDbApi}&anguage=en-US&append_to_response=videos,images,credits,similar`)
            .then(function (response) {
                // handle success
                setData(response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }, []);
    const getReleaseDate = (date) => {
        const newdate = new Date(date);
        const formatedDate = newdate.toLocaleString("default", { month: "long" });
        return formatedDate + " " + newdate.getFullYear();
    };
    let layout = <Spinner type="grow" color="primary" />;
    if (data) {
        layout = <> <div className="background-overlay" style={{ backgroundImage: `linear-gradient(to bottom right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)), url(https://image.tmdb.org/t/p/w500/${data.poster_path ? data.poster_path : data.backdrop_path})` }}></div>
            <div className="movie-content pt-5">
                <Card>
                    <CardImg width="100%" src={`https://image.tmdb.org/t/p/w500${data.poster_path ? data.poster_path : data.backdrop_path}`} alt="movie backdrop" className="movie-image" />
                    <CardImgOverlay className="overlay-content">
                        <div className="share">
                            <FontAwesomeIcon icon={faShareAlt} size="lg" color="white" />
                        </div>
                        <div className="information">
                            <p className="text-white">
                                <span>
                                    <FontAwesomeIcon icon={faStar} size="sm" color="white" />
                                    <FontAwesomeIcon icon={faStar} size="sm" color="white" />
                                </span><br />
                                {data.vote_average}/10
                        </p>
                            <p className="text-white font-weight-bold genere">{getReleaseDate(data.release_date)} <br />
                                <span> {data.genres.length > 0 ? data.genres.map((item, index) => {
                                    return (`${index + 1 >= data.genres.length ? item.name : item.name + " | "}`);
                                }) : ""}</span>
                            </p>
                        </div>
                    </CardImgOverlay>
                    <div className="text-white font-weight-bold d-flex justify-content-center mt-4">
                        <h3>{data.original_title.slice(0, 20)}</h3>
                    </div>
                </Card>
                <div className="user-action text-white">
                    <div className="wishlist">
                        <FontAwesomeIcon icon={faPlus} size="lg" color="white" />
                        <p className="pt-2">My List</p>
                    </div>
                    <div className="play">
                        <FontAwesomeIcon icon={faPlayCircle} size="lg" color="white" className="play-icon" />
                    </div>
                    <div className="download">
                        <FontAwesomeIcon icon={faDownload} size="lg" color="white" />
                        <p className="pt-2">Download</p>
                    </div>
                </div>

                <div className="movie-info mb-5">
                    <div className="plot">
                        <h3 className="p-2">The Plot</h3>
                        <div className="seprator-red"></div>
                        <p className="plot-description p-2">{data.overview}</p>
                    </div>
                    <div className="cast">
                        <h3 className="p-2">Cast</h3>
                        <div className="seprator-yellow"></div>
                        <ScrollContainer className="scroll-container cast-holder p-2" horizontal={true}>
                            {data.credits.cast.length > 0 ? data.credits.cast.map((item, index) => {
                                return (
                                    <div className="cast-item mt-2" key={index}>
                                        <img src={`${item.profile_path ? "https://image.tmdb.org/t/p/w500" + item.profile_path : "https://www.pngarts.com/files/6/User-Avatar-in-Suit-PNG.png"}`} alt="cast photo" className="cast-photo" />
                                        <p className="cast-name">{item.name}</p>
                                    </div>
                                );
                            }) : ""}
                        </ScrollContainer>
                    </div>
                    <div className="trailers">
                        <h3 className="p-2">Trailers</h3>
                        <div className="seprator-blue"></div>
                        <div className="trailer-container p-2 mt-3">
                            <iframe src={`https://www.youtube.com/embed/${data.videos.results.length > 0 ? data.videos.results[0].key : ""}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        </div>
                    </div>
                </div>
                <style>{`
                    ${!props.match.params.itemId ? "" : "body .app-bar-container{display: none;}"}
                `}</style>
            </div></>;
    }
    return (
        <section className="single-movie-page">
            {layout}
        </section >
    );
};

export default SingleMoviePage;
